import React, { useState, useEffect } from "react";
import "./sessions.css";
import Levels from "./components/Levels";
import PreviousSession from "./components/PreviousSession";
import { useParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import { fetchSessions as fetchSessionsUtil } from "../../../utils/fetchSessions";

function OtherProfessionalsSessions() {
  const { sesion } = useParams();
  const [load, setLoad] = useState(false);
  const [classes, setClasses] = useState([]);
  const [otherSessions, setOtherSessions] = useState([]);

  useEffect(() => {
    const load = async () => {
      setLoad(true);
      try {
        const json = await fetchSessionsUtil();
        setClasses(
          json.sessions.find((s) => s.session === sesion)?.classes || [],
        );
        setOtherSessions(json.sessions.filter((s) => s.session !== sesion));
      } catch (err) {
        console.error(err);
      } finally {
        setLoad(false);
      }
    };
    load();
  }, [sesion]);

  return (
    <div className="cr_page">
      <div className="cr_header">
        <div>
          <p className="cr_overline">Academic Tools</p>
          <h2>Professionals</h2>
          <p className="cr_subtitle">
            View professional course results by session and level.
          </p>
        </div>
      </div>

      {load && <Loader />}

      <div className="cr_section">
        <div className="cr_section_head">
          <span className="cr_section_label">Session</span>
          <span className="cr_session_badge">{sesion}</span>
        </div>
        <Levels session={sesion} classes={classes} />
      </div>

      {otherSessions.length > 0 && (
        <div className="cr_section">
          <div className="cr_section_head">
            <span className="cr_section_label">Other Sessions</span>
          </div>
          <div className="cr_session_list">
            {otherSessions.map((s) => (
              <PreviousSession key={s.session} session={s.session} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default OtherProfessionalsSessions;
